<app-hero-slide></app-hero-slide>
<!-- sections -->
<app-lasted-blog></app-lasted-blog>
<app-popular-blog></app-popular-blog>
<app-news-blog></app-news-blog>
<app-ideas-blog></app-ideas-blog>
